<script lang="ts">
	let {
		tilesX,
		tilesY,
		width,
		height
	}: {
		tilesX: number;
		tilesY: number;
		width: number;
		height: number;
	} = $props();

	let strokeWidth = $state(1);
	let sizeX = $derived((width - strokeWidth) / tilesX);
	let sizeY = $derived((height - strokeWidth) / tilesY);
</script>

{#each Array.from({ length: tilesX }) as _, x}
	<path
		d={`
				M ${x * sizeX + 1} 1
				L ${x * sizeX + 1} ${height}
			`}
		fill="none"
		stroke="#c0bcb3"
		stroke-width={strokeWidth}
	/>
{/each}
{#each Array.from({ length: tilesY }) as _, y}
	<path
		d={`
				M 1 ${y * sizeY + 1}
				L ${width} ${y * sizeY + 1}
			`}
		fill="none"
		stroke="#c0bcb3"
		stroke-width={strokeWidth}
	/>
{/each}

<path
	d={`
				M ${width - 1} 1
				L ${width - 1} ${width - 1}
			`}
	fill="none"
	stroke="#c0bcb3"
	stroke-width={strokeWidth}
/>
<path
	d={`
				M 1 ${height - 1}
				L ${height} ${height - 1}
			`}
	fill="none"
	stroke="#c0bcb3"
	stroke-width={strokeWidth}
/>
